import { emptyNull } from '../../misc';
import mAnage from '../model/state';

export const withManageConfig = (cfg = emptyNull) => ({
  ...mAnage.config,
  ...cfg
});
